import React from "react";
import {
  Car,
  MapPin,
  Clock,
  Shield,
  Users,
  Fuel,
  Route,
  Smartphone,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "Fleet Management",
    description:
      "Build comprehensive systems for vehicle tracking and fleet optimization",
    icon: Car,
  },
  {
    title: "Ride-Sharing Platforms",
    description:
      "Develop ride-hailing apps with real-time matching and routing",
    icon: Users,
  },
  {
    title: "Route Optimization",
    description:
      "Implement AI-driven route planning for efficiency and cost savings",
    icon: Route,
  },
  {
    title: "Real-Time Tracking",
    description: "GPS-enabled tracking systems for vehicles and shipments",
    icon: MapPin,
  },
  {
    title: "Driver Management",
    description:
      "Create apps for driver onboarding, scheduling, and performance",
    icon: Smartphone,
  },
  {
    title: "Fuel Management",
    description: "Build fuel tracking and cost optimization solutions",
    icon: Fuel,
  },
  {
    title: "Maintenance Systems",
    description: "Predictive maintenance scheduling and service management",
    icon: Clock,
  },
  {
    title: "Safety & Compliance",
    description: "Ensure regulatory compliance and driver safety monitoring",
    icon: Shield,
  },
];

const STATS = [
  { value: "50M+", label: "Rides Completed" },
  { value: "100K+", label: "Vehicles Tracked" },
  { value: "25%", label: "Cost Reduction" },
  { value: "Real-time", label: "Tracking" },
];

const TransportIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="transport"
      industryTitle="Transport"
      industrySubtitle="& Mobility"
      heroDescription="Revolutionizing transportation with smart mobility solutions, fleet management systems, and ride-sharing platforms that optimize operations and enhance passenger experience."
      themeColor="#3b82f6"
      themeColorLight="#60a5fa"
      themeGradient="linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 50%, #3b82f6 100%)"
      HeroIcon={Car}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1565891741441-64926e441838?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default TransportIndustryPage;
